/**
 * API Configuration
 *
 * Uses environment variables to configure the API base URL for different environments.
 *
 * Environment variables:
 * - VUE_APP_API_BASE_URL: Full API base URL (e.g., https://tehoaly.shieldgrove.com/api)
 *
 * Development: http://localhost:3000/api
 * Production: https://tehoaly.shieldgrove.com/api
 */

const API_BASE_URL =
  process.env.VUE_APP_API_BASE_URL || "http://localhost:3000/api";

export const config = {
  apiBaseUrl: API_BASE_URL,
};

/**
 * Helper function to build API URLs
 */
export function apiUrl(path: string): string {
  // Remove leading slash if present to avoid double slashes
  const cleanPath = path.startsWith("/") ? path.slice(1) : path;
  return `${API_BASE_URL}/${cleanPath}`;
}
